export const YOUTUBE_SIGN = 'youtube';
export const YOUTUBE_SHORT_SIGN = 'youtu.be';
export const RUTUBE_SIGN = 'rutube';
export const VK_SIGN = 'vk';
export const VK_VIDEO_SIGN = 'video';
